export const environment = {
  production: false,
  env: 'staging',
  useMockApi: false,
  apiUrl: 'https://apiv3-staging.a-book.dk/1.0',
  apiV2Url: null as string | null,
  authServer: 'https://demo.aktivby.dk/auth',
  useAuthServer: true, // DO NOT CHANGE THIS IN PROD //  will disable all Authentication // false is not working yet!
  showExampleTemplates: false,
};

const hostname = window.location.hostname;

if (hostname.includes('-staging.a-book.dk')) {
  environment.apiUrl = 'https://apiv3-staging.a-book.dk/1.0';
  environment.apiV2Url = 'https://api-staging.a-book.dk/api';
  environment.authServer = `https://${hostname.split('-')[0]}-auth-staging.a-book.dk`;
}

if (hostname.includes('-dev.a-book.dk')) {
  environment.apiUrl = 'https://apiv3-dev.a-book.dk/1.0';
  environment.authServer = `https://auth-dev.a-book.dk`;
}

// Quick fix for odense staging, since we have no staging domain for this project
if (hostname === 'odense-admin.a-book.dk') {
  environment.apiUrl = 'https://odense-apiv3.a-book.dk/1.0';
  environment.apiV2Url = null;
  environment.authServer = `https://odense-auth.a-book.dk`;
}
